/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedCrossIcon16Solid = forwardRef('MedCrossIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.25 1C5.56 1 5 1.56 5 2.25V5H2.25C1.56 5 1 5.56 1 6.25v3.5c0 .69.56 1.25 1.25 1.25H5v2.75c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25V11h2.75c.69 0 1.25-.56 1.25-1.25v-3.5C15 5.56 14.44 5 13.75 5H11V2.25C11 1.56 10.44 1 9.75 1h-3.5Z" })));
});
